import { useMutation } from '@tanstack/react-query';
import { debounce } from 'lodash';
import { useCallback, useMemo, useState } from 'react';
import { useCommonApi } from '../api';
import { SeznamAutocomplete, SeznamAutocompleteItem } from '../types/external/seznamAutocomplete';

export const useGetAutocompleteAddress = () => {
  const [autocompleteItems, setAutocompleteItems] = useState<
    { id: number; name: string; data: SeznamAutocompleteItem }[]
  >([]);

  const { mutate: getAddressAutocomplete, isPending: isLoadingData } = useMutation(
    useCommonApi().getAutocompleteAddress()
  );

  const searchFunction = useCallback(
    (query: string) => {
      if (!query.trim()) {
        setAutocompleteItems([]);
        return;
      }

      try {
        getAddressAutocomplete(
          { query },
          {
            onSuccess: (data) => {
              if (data) {
                const parsedData = data?.map((item: SeznamAutocomplete, idx) => ({
                  id: idx,
                  name: `${item.name}, ${item.data.location}`,
                  data: item.data
                }));
                setAutocompleteItems(parsedData);
              }
            },
            onError: (error) => {
              console.error('Autocomplete search error:', error);
              setAutocompleteItems([]);
            }
          }
        );
      } catch (e) {
        console.error(e);
        setAutocompleteItems([]);
      }
    },
    [getAddressAutocomplete]
  );

  // Debounced funkce zabalená v useMemo aby se nevytvářela při každém renderu
  const handleOnSearch = useMemo(() => debounce(searchFunction, 500), [searchFunction]);

  const cleanup = useCallback(() => {
    handleOnSearch.cancel();
  }, [handleOnSearch]);

  return {
    autocompleteItems,
    setAutocompleteItems,
    handleOnSearch,
    isLoadingData,
    cleanup
  };
};
